import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DataService } from './service/data.service';
// import { MatSnackBarModule, MatIconModule, MatButtonModule, MatDialogModule } from '@angular/material';
import { SnackbarComponent } from './common/snackbar/snackbar.component';
import { IonicStorageModule } from '@ionic/storage';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './auth/auth-guard.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ConnectionService } from './service/connection.service';
import { LoginService } from './service/login.service';
import { TransferStockNewService } from './home/items/stock/stock-transfer/transfer-stock-new/transfer-stock-new.service';
import { SalesInvoiceService } from './home/sales/sales-invoice/sales-invoice.service';
import { DcNewService } from './home/sales/dc/dc-new/dc-new.service';
import { AlertWindowModule } from './common/alert-window/alert-window.module';
import { DeleteAlertModule } from './common/delete-alert/delete-alert.module';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { FullSpinnerInterceptor } from './common/full-spinner/full-spinner.interceptor';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    AppComponent,
    SnackbarComponent,
  
  ],
  entryComponents: [SnackbarComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    IonicStorageModule.forRoot(
      {
        name: '__ecbill_web',
        driverOrder: ['indexeddb', 'localstorage', 'sqlite']
      }
    ),
    HttpClientModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    AlertWindowModule,
    DeleteAlertModule,
    MatProgressBarModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FullSpinnerInterceptor,
      multi: true,
    },
    DataService, AuthGuardService, ConnectionService, LoginService, TransferStockNewService, DcNewService],
  bootstrap: [AppComponent]
})
export class AppModule { }
